// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AlzaSyCJ8batyw8Ns9MEiYagW309CZWfJCzvLPc",
  authDomain: "agrid-telu.firebaseapp.com",
  databaseURL: "https://agrid-telu-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "agrid-telu",
  storageBucket: "agrid-telu.firebasestorage.app",
};

// Inisialisasi Firebase
const app = initializeApp(firebaseConfig);
const db = getDatabase(app);

export { db }; // Export database agar bisa dipakai di Dashboard.js